import { Controller } from '@hotwired/stimulus'
import { client } from '../../../../inquiry/api/common/client'

export default class extends Controller {
  static values = {
    diffRecordIds: Array,
    diffVacancyFacilityIds: Array,
    lastUpdatedAt: String,
    facilityTaskId: Number,
  }

  static targets = [
    'highPriority', // 緊急案件
    'note', // 見学時ヒアリング時の条件
    'picSelect', // 対応者
    'operationLog', // 対応ログ
    'singleVacancies', // 個室空室数
    'doubleVacancies', // 二人部屋空室数
    'numberOfWaiters', // 待機人数
    'status', // 対応ステータス
    'unavailableReason', // 見学設定不可理由
    'caAgenda', // CAへの共有事項
    'introductionRequestedDate', // 紹介カード依頼日
    'odId', // 担当OD
    'completedOn', // 対応完了日
    'transferId', // 伝達者
    'transferredOn', // 伝達完了日
  ]

  connect () {
    this.enableSelect2()
    this.addClassToDifferentRow()
  }

  changeDisabledHiddenField (e) {
    const hiddenIdField = document.getElementById(`ca_request_facility_task_update_form_facility_task_attributes_${this.facilityTaskIdValue}_id`)
    hiddenIdField.disabled = false

    const hiddenLastUpdatedAtField = document.getElementById(`ca_request_facility_task_update_form_facility_task_attributes_${this.facilityTaskIdValue}_last_updated_at`)
    hiddenLastUpdatedAtField.disabled = false
  }

  enableSelect2 () {
    if (this.picSelectTarget.classList.contains('select-field')) {
      $(this.picSelectTarget).select2({
        language: {
          noResults: () => '対応者が見つかりません',
        },
        minimumInputLength: 0,
      })
      $(this.picSelectTarget).on('select2:open', () => { this.diffRecordColumns() })
      $(this.picSelectTarget).on('select2:select', () => { this.changeDisabledHiddenField() })
    } else {
      $(this.picSelectTarget).select2({
        language: {
          noResults: () => '対応者が見つかりません',
          inputTooShort: () => '1文字以上入力してください',
        },
        minimumInputLength: 1,
      })
    }
  }

  params () {
    return {
      high_priority: this.highPriorityTarget.checked,
      note: this.noteTarget.value,
      pic_id: this.picSelectTarget.value,
      operation_log: this.operationLogTarget.value,
      single_vacancies: this.singleVacanciesTarget.value,
      double_vacancies: this.doubleVacanciesTarget.value,
      number_of_waiters: this.numberOfWaitersTarget.value,
      status: this.statusTarget.value,
      unavailable_reason: this.unavailableReasonTarget.value,
      ca_agenda: this.caAgendaTarget.value,
      introduction_requested_date: this.introductionRequestedDateTarget.value,
      od_id: this.odIdTarget.value,
      completed_on: this.completedOnTarget.value,
      last_updated_at: this.lastUpdatedAtValue,
      transfer_id: this.transferIdTarget.value,
      transferred_on: this.transferredOnTarget.value,
    }
  }

  async diffRecordColumns () {
    await client.get(`/api/admin/ca/request/facility_tasks/${this.facilityTaskIdValue}/diff_record_columns/`, { params: this.params() })
      .then(response => {
        this.addClassToDifferentFields(response.data)
      })
  }

  addClassToDifferentRow () {
    if (this.diffRecordIdsValue.length === 0 && this.diffVacancyFacilityIdsValue.length === 0) return

    this.diffRecordIdsValue.forEach(facilityTaskId => {
      this.addClassById(`facility_task_id_${facilityTaskId}`)
    })
    this.diffVacancyFacilityIdsValue.forEach(facilityId => {
      this.addVacancyClass(`facility_id_${facilityId}`)
    })
  }

  addClassToDifferentFields (columnNames) {
    columnNames.forEach(columnName => {
      this.addClassById(columnName + `_${this.facilityTaskIdValue}`)
    })
  }

  addClassById (id) {
    document.getElementById(id).classList.add('viewcomponent::admin::ca::request::facility_tasks::border-red')
  }

  addVacancyClass (className) {
    // classNameを持つ全ての要素に対して'viewcomponent::admin::ca::request::facility_tasks::border-blue'クラスを追加する
    document.querySelectorAll(`.${className}`).forEach(el => {
      el.classList.add('viewcomponent::admin::ca::request::facility_tasks::border-blue')
    })
  }

  changeDisabledHiddenFieldAndChangeTransferredOnField (e) {
    this.changeDisabledHiddenField()

    const transferredOnField = document.getElementById(`ca_request_facility_task_update_form_facility_task_attributes_${this.facilityTaskIdValue}_transferred_on`)
    transferredOnField.disabled = e.target.value === ''
  }

  // 同じfacility_idを持つ全てのsingle/double/number_of_waitersを一括連動
  syncVacancyFields (e) {
    const input = e.target
    const facilityIdMatch = Array.from(input.classList).find(cls => cls.startsWith('facility_id_'))
    if (!facilityIdMatch) return
    const facilityId = facilityIdMatch.replace('facility_id_', '')

    const singleFields = document.querySelectorAll(`.single_vacancies.facility_id_${facilityId}`)
    const doubleFields = document.querySelectorAll(`.double_vacancies.facility_id_${facilityId}`)
    const waitersFields = document.querySelectorAll(`.number_of_waiters.facility_id_${facilityId}`)

    if (input.name && input.name.endsWith('[single_vacancies]')) {
      singleFields.forEach(f => { f.value = input.value })
    } else if (input.name && input.name.endsWith('[double_vacancies]')) {
      doubleFields.forEach(f => { f.value = input.value })
    } else if (input.name && input.name.endsWith('[number_of_waiters]')) {
      waitersFields.forEach(f => { f.value = input.value })
    }
  }
}
